import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import NotFound from "../pages/NotFound";
import Layout from "../containers/Layout";

import TargetAchievement from "../pages/TargetAchievement";
import UserManagement from "../pages/UserManagement";
import Leaderboard from "../pages/Leaderboard";
import Dashboard from "../pages/Dashboard";
import Reports from "../pages/Reports";
import Centres from "../pages/Centres";
import Qc from "../pages/Qc";

// configuration module pages
import Configuration from "../pages/Configuration";
import ManageAward from "../pages/configuration/ManageAward";
import ManageScore from "../pages/configuration/ManageScore";
import Targets from "../pages/configuration/Targets";
import helperMethods from "../helper/helperMethods";
import DataInput from "../pages/DataInput";
import usePermission from "../helper/usePermission";

function PrivateRoutes() {
  const { permissions } = usePermission();

  const userAccess = helperMethods.userNavigationTabAccess(permissions);

  const routes = [
    { path: "/dashboard", key: "dashboard" },
    { path: "/leaderboard", key: "leaderboard" },
    { path: "/qc", key: "qc" },
    { path: "/target-achievement", key: "target_achievements" },
    { path: "/data-input", key: "data_input" },
    { path: "/user-management", key: "user_management" },
    { path: "/reports", key: "reports" },
    { path: "/centres", key: "centres" },
  ];

  const configurationRoutes = [
    { path: "manage-score", key: "manage_score", component: <ManageScore /> },
    { path: "manage-award", key: "manage_award", component: <ManageAward /> },
    { path: "targets", key: "targets", component: <Targets /> },
  ];

  const getRedirectUrl = () => {
    
    const firstAccessibleRout: any = routes.find((route) => userAccess[route.key]);
    if(firstAccessibleRout){
      return firstAccessibleRout.path || "/";
    }

    return routes[0]?.path || "/";
  };

  const redirectUrl = getRedirectUrl();


  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* Redirect to the first accessible route */}
        <Route index element={<Navigate to={redirectUrl} replace />} />

        {/* Redirect for unmatched routes */}
        <Route path="*" element={<Navigate to={redirectUrl} replace />} />

        {/* Define routes with access validation */}
        {routes.map(({ path, key }) => {
          return (
            userAccess[key] && (
              <Route key={path} path={path} element={getPageComponent(key)} />
            )
          );
        })}

        {/* Dynamic Configuration Nested Routes */}
        {userAccess.configuration && (
          <Route path="/configuration" element={<Configuration />}>
            {/* Dynamically generate child routes */}
            {configurationRoutes.map(({ path, component, key }) => (
              <Route key={key} path={path} element={component} />
            ))}
          </Route>
        )}
      </Route>
    </Routes>
  );
}

// Helper to map keys to page components
const getPageComponent = (key: string) => {
  const pages: any = {
    dashboard: <Dashboard />,
    leaderboard: <Leaderboard />,
    qc: <Qc />,
    target_achievements: <TargetAchievement />,
    data_input: <DataInput />,
    user_management: <UserManagement />,
    reports: <Reports />,
    centres: <Centres />,
  };

  return pages[key] || null;
};

export default PrivateRoutes;
